"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var fn_1 = require("ayvri-std/lib/fn");
var search_input_1 = require("ayvri-ui/lib/search-input");
var usermenu_1 = require("ayvri-ui/lib/usermenu");
var React = require("react");
var react_1 = require("react");
var typestyle_1 = require("typestyle");
var env_1 = require("../../helpers/env");
var layouts_1 = require("../../styles/layouts");
var state_1 = require("./state");
var styles_1 = require("./styles");
// a matchMedia compatible device query
var kMobileDeviceQuery = '(max-width: 900px)';
var kHeaderLinks = [['API', '/pages/api'], ['Race', '/pages/race']];
var kIsBrowser = typeof matchMedia !== 'undefined';
var kInitialMode = kIsBrowser && matchMedia(kMobileDeviceQuery).matches ? 'mobile' : 'desktop';
exports.Header = function (props) {
    var staticSrcPath = props.staticSrcPath, loginState = props.loginState, initialSearchText = props.initialSearchText, onSearchSubmit = props.onSearchSubmit;
    var _a = react_1.useReducer(state_1.reducer, {
        displayMode: kInitialMode,
    }), _b = _a[0], displayMode = _b.displayMode, searchCollapsed = _b.searchCollapsed, dispatch = _a[1];
    react_1.useEffect(function () {
        var isMobile = matchMedia(kMobileDeviceQuery);
        // change monitoring not supported on edge, so disable
        if (typeof isMobile.addEventListener === 'function') {
            isMobile.addEventListener('change', function () {
                dispatch(state_1.toggleDisplayMode(isMobile.matches ? 'mobile' : 'desktop'));
            });
        }
    }, []);
    return (React.createElement("div", { className: styles_1.styles.wrapper },
        React.createElement("div", { className: typestyle_1.classes(layouts_1.centerColumn, styles_1.styles.container) },
            React.createElement("div", { className: styles_1.styles.section },
                React.createElement("a", { href: '/' },
                    React.createElement("img", { className: styles_1.styles.logo, src: staticSrcPath + "/assets/images/logos/ayvri-logo-color.svg" })),
                React.createElement("div", { className: styles_1.styles.searchContainer }, renderSearch()),
                React.createElement("a", { href: '/upload', className: styles_1.styles.createYourOwn, style: { display: searchCollapsed === false ? 'none' : 'inherit' } },
                    React.createElement("span", null, "Create Your Own"),
                    React.createElement("img", { src: env_1.env().staticSrcPath() + "/assets/images/icons/upload_arrow_color.svg" }))),
            React.createElement("div", { className: typestyle_1.classes(styles_1.styles.section, styles_1.styles.linksSection), style: { display: searchCollapsed === false ? 'none' : 'grid' } },
                renderHeaderLinks(),
                renderUserMenu()))));
    function renderSearch() {
        if (!kIsBrowser) {
            return null;
        }
        return (React.createElement(search_input_1.SearchInput, { placeholder: 'explore', mode: displayMode, collapsed: fn_1.def(displayMode === 'mobile', searchCollapsed), initialText: initialSearchText, onToggleCollapsed: function (collapsed) { return dispatch(state_1.toggleSearchCollapsed(collapsed)); }, onSubmit: fn_1.def(redirectToExplorePage, onSearchSubmit) }));
    }
    function renderHeaderLinks() {
        return kHeaderLinks.map(function (_a) {
            var name = _a[0], href = _a[1];
            return (React.createElement("a", { className: styles_1.styles.headerLink, key: name, href: href }, name));
        });
    }
    function renderUserMenu() {
        if (loginState.type !== 'logged_in') {
            return React.createElement("a", { href: loginState.loginUrl }, "Sign In");
        }
        var user = __assign({}, loginState.user, { avatarUrl: fn_1.def(env_1.env().staticSrcPath() + "/assets/images/logos/_a_transparent.svg", loginState.user.avatarUrl) });
        return (React.createElement("div", { className: styles_1.styles.userMenu },
            React.createElement(usermenu_1.UserMenu, __assign({}, user, { arrowUrl: staticSrcPath + "/assets/images/icons/arrow-down.svg", profileUrl: "/profile/" + loginState.user.handle }),
                React.createElement("a", { href: "/profile/" + loginState.user.handle }, "Profile"),
                React.createElement("a", { href: '/settings' }, "Settings"),
                React.createElement("a", { href: '/settings/pro' }, "PRO Account"),
                React.createElement("a", { href: '/logout' }, "Logout"))));
    }
    function redirectToExplorePage(searchText) {
        window.location.replace("/explore?q=" + encodeURIComponent(searchText));
    }
};
exports.Header.displayName = 'Header';
